export default [
	'Developer',
	'Institutional Investor',
	'Private Capital Investor'
];